import Icon from '../components/Icon.vue'

Icon.register({"flickr":{"width":1536,"height":1792,"paths":[{"d":"M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM698 896q0-88-62-150t-150-62-150 62-62 150 62 150 150 62 150-62 62-150zM1262 896q0-88-62-150t-150-62-150 62-62 150 62 150 150 62 150-62 62-150z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flickr.js
// module id = 568
// module chunks = 0